export const INDIVIDUAL_ALERT_TYPES = {
  SIMPLE: 'simple',
}

export const PAYMENT_TYPE = {
  FAILED: 'failedPayment',
  OUTSTANDING: 'outstandingPayment',
}

export const RECURRING_PAYMENT = 'RECURRING'

export const FAILED_PAYMENT_PARAM = 'failedpayment'

export const MAXIMUM_CREDIT_TOTAL = 1000

export const UNLIMITED = 'Unlimited'
